import * as React from "react";
import { cn } from "@/lib/utils";

/** Loading spinner with smooth animation. */
export interface SpinnerProps extends React.HTMLAttributes<HTMLDivElement> {
  size?: "sm" | "default" | "lg";
}

const sizeMap = {
  sm: "h-4 w-4 border-2",
  default: "h-6 w-6 border-2",
  lg: "h-8 w-8 border-[3px]",
};

const Spinner = React.forwardRef<HTMLDivElement, SpinnerProps>(
  ({ className, size = "default", ...props }, ref) => (
    <div
      ref={ref}
      role="status"
      aria-label="Loading"
      className={cn(
        "inline-block rounded-full border-primary/30 border-t-primary animate-spin-smooth",
        sizeMap[size],
        className
      )}
      {...props}
    >
      <span className="sr-only">Loading…</span>
    </div>
  )
);
Spinner.displayName = "Spinner";

export { Spinner };
